import React from "react";

// Keeping track of application state
import { useSelector, useDispatch } from "react-redux";
import {
  setMenuOpen,
  selectMenuOpen,
  setActivePage,
  setActiveMenu,
} from "../../redux/features/applicationState/applicationStateSlice";

// Icons
import {
  Bars3BottomLeftIcon,
  UserGroupIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";

// Custom components
import { HeaderButton } from "../Buttons/Buttons";

const MobileHeader = () => {
  const dispatch = useDispatch();
  const menuOpen = useSelector(selectMenuOpen);

  const handleMenuOpenToggle = () => {
    dispatch(setMenuOpen(!menuOpen));
  };

  const handleActivePageUpdate = (activeMenu, pageLink) => {
    dispatch(setActiveMenu(activeMenu));
    dispatch(setActivePage(pageLink));
  };

  return (
    <div
      className={`top-0 z-[995] fixed bg-white
                  flex flex-row items-center justify-start w-full Xh-12 p-4
                  transition-all duration-200
                  ${menuOpen ? "left-[21rem]" : "left-0"}   
                  md:hidden  
                `}
    >
      {/* Left side */}
      <div className="flex flex-1 items-center justify-start space-x-3 Xbg-red-500">
        <HeaderButton
          Icon={Bars3BottomLeftIcon}
          onClickFunction={handleMenuOpenToggle}
        />
      </div>

      {/* Right side */}
      <div className="flex flex-1 items-center justify-end space-x-5 Xbg-blue-500">
        <HeaderButton
          Icon={UserGroupIcon}
          onClickFunction={() => {
            handleActivePageUpdate("patients", "/patients/database");
          }}
          pageLink={"/patients/database"}
        />
        <HeaderButton
          Icon={HomeIcon}
          onClickFunction={() => {
            handleActivePageUpdate("home", "/");
          }}
          pageLink={"/"}
        />
      </div>
    </div>
  );
};

export default MobileHeader;
